import { Header } from './Header.js'
import { Footer } from './Footer.js'
import './Home.css'

export function Home () {
  return (
    <div>
      <Header />
      <main>
        <section className='hero'>
          <div className='container'>
            <h1>Welcome to Fern and Fable</h1>
            <p>Create unforgettable outdoor dining experiences</p>
            <p className='location-tagline'>Luxury Picnics in Utah County</p>
            <div className='logo-container'>
              <img src="images/logo.jpg" alt="Fern and Fable Logo" className="logo" />
            </div>
            <img
              src='images/home.jpg'
              alt='Fern and Fable Picnic Setup'
              srcSet='
              images/home-sm.jpg  480w,
              images/home-md.jpg  768w,
              images/home-lg.jpg 1024w,
              images/home.jpg    1440w
            '
              sizes='(max-width: 480px) 480px,
                   (max-width: 768px) 768px,
                   (max-width: 1024px) 1024px,
                   1440px'
              className='hero-image'
            />
            <a href='/book' className='button book-button'>
              Book Now
            </a>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  )
}
